import { useMemo, useState } from "react";
import { CONTACT_EMAIL_PARTS, buildEmail, obfuscateEmail } from "../constants/contactEmail";

export default function ProtectedEmailLink({
  parts = CONTACT_EMAIL_PARTS,
  className = "",
  testid,
}) {
  const mailto = useMemo(() => `mailto:${buildEmail(parts)}`, [parts]);
  const [href, setHref] = useState("#");

  const onClick = (e) => {
    e.preventDefault();
    window.location.href = mailto;
  };

  return (
    <a
      href={href}
      onMouseEnter={() => setHref(mailto)}
      onMouseLeave={() => setHref("#")}
      onFocus={() => setHref(mailto)}
      onBlur={() => setHref("#")}
      onClick={onClick}
      className={className}
      data-testid={testid}
      rel="nofollow"
    >
      {obfuscateEmail(parts)}
    </a>
  );
}
